import { useConfigStore } from '@/stores/configStore';

export const useCustomMenuContentById = (id?: string, contentId?: string) => {
    const language = useConfigStore((state) => state.config.ui.language);
    const listBuildingMenus = useConfigStore((state) => state.config.server?.buildingMenus);
    const buildingMenus = listBuildingMenus?.[language];

    if (!id) return [];
    const customMenus = buildingMenus?.find((item) => item.id === id);
    const customContent = customMenus?.customContent;

    return customContent?.find((item) => item.id === contentId) || null;
};
